import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Email } from 'src/app/models/email';
import { User } from 'src/app/models/user';
import { first } from 'rxjs/operators';
import { Constants } from 'src/app/helpers/constants';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EmailService } from 'src/app/services/email.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  env = environment;
  contactForm: FormGroup;
  submitted = false;
  loader = false;
  message = "";
  classType = "";
  messageType = ""
  public siteKey: any;

  constructor(private formBuilder: FormBuilder, private emailService: EmailService,
    private userService: UserService) { }

  ngOnInit(): void {
    this.contactForm = this.formBuilder.group(
      {
        Name: ["", { validators: [Validators.required], updateOn: "change" }],
        Email: ["", { validators: [Validators.required, Validators.email], updateOn: "change" }],
        Phone: ["", { validators: [Validators.pattern(Constants.val_pattern_number)], updateOn: 'change' }],
        Subject: ["", { validators: [Validators.required], updateOn: "change" }],
        Message: ["", { validators: [Validators.required], updateOn: "change" }],
        recaptcha: ["", { validators: [Validators.required], updateOn: "change" }]
      });
    this.siteKey = environment.siteKey;
  }
  get f() { return this.contactForm.controls; }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.contactForm.invalid) {
      return;
    }
    this.loader = true;
    let data: Email = new Email;
    data.toEmail = environment.email;
    data.subject = 'Contact Us Page Enquery | ' + this.contactForm.value.Subject;
    data.body = 'Hi Admin, <br /><br /> New enquiry has been made from website. Please see below details <br />'
      + '<br /><br /> Name: ' + this.contactForm.value.Name
      + '<br /><br /> Email: ' + this.contactForm.value.Email
      + '<br /><br /> Phone: ' + this.contactForm.value.Phone
      + '<br /><br /> Message: ' + this.contactForm.value.Message;
    let userdata: User = new User;
    userdata.userName = environment.username;
    userdata.password = environment.password;
    this.userService.authenticate(userdata)
      .pipe(first())
      .subscribe(
        userdata => {
          localStorage.setItem('currentSaraAppTokenUser', JSON.stringify(userdata));
          this.emailService.sendEmail(data)
            .pipe(first())
            .subscribe(
              data => {
                this.classType = "alert-success";
                this.messageType = "Success";
                this.message = "Thank you! Your query has been submitted. Please wait for the response from support team.";
                this.contactForm.reset();
                this.submitted = false;
                this.loader = false;
                localStorage.removeItem('currentSaraAppTokenUser');
              },
              error => {
                this.classType = "alert-danger";
                this.messageType = "Failed";
                this.message = "Sorry! We were unable to submit your query. Please try after sometime or email to: " + environment.email;
                this.loader = false;
                localStorage.removeItem('currentSaraAppTokenUser');
              });
        },
        error => {
          this.classType = "alert-danger";
          this.messageType = "Failed";
          this.message = "Sorry! We were unable to submit your query. Please try after sometime or email to: ";
        });
  }
}
